import { CALL_API } from "admin/middlewares/api";

export const SSN_BLOCK_INFO_REQUEST = "SSN_BLOCK_INFO_REQUEST";
export const SSN_BLOCK_INFO_SUCCESS = "SSN_BLOCK_INFO_SUCCESS";
export const SSN_BLOCK_INFO_ERROR = "SSN_BLOCK_INFO_ERROR";

export const SSN_UNBLOCK_INFO_REQUEST = "SSN_UNBLOCK_INFO_REQUEST";
export const SSN_UNBLOCK_INFO_SUCCESS = "SSN_UNBLOCK_INFO_SUCCESS";
export const SSN_UNBLOCK_INFO_ERROR = "SSN_UNBLOCK_INFO_ERROR";

export function block_ssn(ssn, reason) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/add-blocked-ssn",
      authenticatedRequest: true,
      method: "POST",
      data: { Ssn: ssn, Reason: reason },
      types: [
        SSN_BLOCK_INFO_REQUEST,
        SSN_BLOCK_INFO_SUCCESS,
        SSN_BLOCK_INFO_ERROR,
      ],
    },
  };
}

export function unblock_ssn(ssn) {
  return {
    [CALL_API]: {
      endpoint: "/api/admin/loans/remove-blocked-ssn",
      authenticatedRequest: true,
      method: "POST",
      data: { Ssn: ssn },
      types: [
        SSN_UNBLOCK_INFO_REQUEST,
        SSN_UNBLOCK_INFO_SUCCESS,
        SSN_UNBLOCK_INFO_ERROR,
      ],
    },
  };
}
